// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Sovra","label":"styles_label__2dWwe"};